import { Box } from '@mui/material';

const CardWrapper = (props) => {
    const { children, sx, ...boxProps } = props;
    const sxOverrides = Array.isArray(sx) ? sx : sx ? [sx] : [];

    return (
        <Box
            {...boxProps}
            sx={[
                {
                    display: 'flex',
                    width: { xs: 'calc(100% - 16px)', sm: 'calc(100% - 24px)', md: '95%' },
                    maxWidth: '100%',
                    borderRadius: { xs: 1, sm: 2 },
                    background: '#F8F8F8',
                    boxShadow: 1,
                    py: { xs: 1.25, sm: 1 },
                    px: { xs: 1.25, sm: 2 },
                    marginTop: { xs: 0, sm: '-15px' },
                    overflow: 'hidden',
                    boxSizing: 'border-box'
                },
                ...sxOverrides
            ]}
        >
            {children}
        </Box>
    );
};

export default CardWrapper;
